import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Form, TextArea, Secti} from 'semantic-ui-react';
import withChangeHandler from './withChangeHandler';
import ReactHtmlParser from 'react-html-parser';

const MANAGED_PROPS = [
  'id',
  'questionLabel',
  'questionText',
  'modelKey',
  'title',
  'value',
  'style',
];

const TextareaWithChangeHandler = withChangeHandler(TextArea);

export default class extends React.Component {
  static propTypes = {
    /** A unique id */
    id: PropTypes.string,

    /** The label for the question */
    questionLabel: PropTypes.string,

    /** The text for the question */
    questionText: PropTypes.string.isRequired,

    /** The unique key of the property within the form backing model */
    modelKey: PropTypes.string.isRequired,

    /** The current value of the field */
    value: PropTypes.any,
  };

  constructor(props) {
    super(props);

    this.id = props.id;
    this.questionLabel = props.questionLabel;
    this.questionText = props.questionText;
    this.modelKey = props.modelKey;
  }

  render = () => {
    const filteredProps = _.omit(this.props, MANAGED_PROPS);

    return (
      <React.Fragment>
        <p>{ReactHtmlParser(this.questionText)}</p>

        <Form.Field>
          <label htmlFor={this.id}>{this.questionLabel}</label>
          <TextareaWithChangeHandler
            id={this.id}
            modelKey={this.modelKey}
            updateModel={this.props.updateModel}
            onBlur={this.props.blurModel}
            value={this.props.value}
            {...filteredProps}
          />
        </Form.Field>
      </React.Fragment>
    );
  };
}
